import { useConfig } from '@/composables';

const remoteHazardAssetsUrl = useConfig().value.remoteHazardAssets.iconAssetsPathSvg;

export const WARNING_HAZARD_ICONS = {
  // Air Quality
  'ew-air-quality--emergency-warning': `${remoteHazardAssetsUrl}/ew-air-quality--emergency-warning.svg?url`,
  'ew-air-quality--watch-and-act': `${remoteHazardAssetsUrl}/ew-air-quality--watch-and-act.svg?url`,
  'ew-air-quality--advice': `${remoteHazardAssetsUrl}/ew-air-quality--advice.svg?url`,

  // Blizzard
  'ew-blizzard--emergency-warning': `${remoteHazardAssetsUrl}/ew-blizzard--emergency-warning.svg?url`,
  'ew-blizzard--watch-and-act': `${remoteHazardAssetsUrl}/ew-blizzard--watch-and-act.svg?url`,
  'ew-blizzard--advice': `${remoteHazardAssetsUrl}/ew-blizzard--advice.svg?url`,

  // Blowing Snow
  'ew-blowing-snow--emergency-warning': `${remoteHazardAssetsUrl}/ew-blowing-snow--emergency-warning.svg?url`,
  'ew-blowing-snow--watch-and-act': `${remoteHazardAssetsUrl}/ew-blowing-snow--watch-and-act.svg?url`,
  'ew-blowing-snow--advice': `${remoteHazardAssetsUrl}/ew-blowing-snow--advice.svg?url`,

  // Extreme Cold
  'ew-extreme-cold--emergency-warning': `${remoteHazardAssetsUrl}/ew-extreme-cold--emergency-warning.svg?url`,
  'ew-extreme-cold--watch-and-act': `${remoteHazardAssetsUrl}/ew-extreme-cold--watch-and-act.svg?url`,
  'ew-extreme-cold--advice': `${remoteHazardAssetsUrl}/ew-extreme-cold--advice.svg?url`,

  // Flash Flood
  'ew-flash-flood--emergency-warning': `${remoteHazardAssetsUrl}/ew-flash-flood--emergency-warning.svg?url`,
  'ew-flash-flood--watch-and-act': `${remoteHazardAssetsUrl}/ew-flash-flood--watch-and-act.svg?url`,
  'ew-flash-flood--advice': `${remoteHazardAssetsUrl}/ew-flash-flood--advice.svg?url`,

  // Freezing Rain
  'ew-freezing-rain--emergency-warning': `${remoteHazardAssetsUrl}/ew-freezing-rain--emergency-warning.svg?url`,
  'ew-freezing-rain--watch-and-act': `${remoteHazardAssetsUrl}/ew-freezing-rain--watch-and-act.svg?url`,
  'ew-freezing-rain--advice': `${remoteHazardAssetsUrl}/ew-freezing-rain--advice.svg?url`,

  // Generic (Other Warning)
  'ew-other-warning--emergency-warning': `${remoteHazardAssetsUrl}/ew-other-warning--emergency-warning.svg?url`,
  'ew-other-warning--watch-and-act': `${remoteHazardAssetsUrl}/ew-other-warning--watch-and-act.svg?url`,

  // Ice Jam
  'ew-ice-jam--emergency-warning': `${remoteHazardAssetsUrl}/ew-ice-jam--emergency-warning.svg?url`,
  'ew-ice-jam--watch-and-act': `${remoteHazardAssetsUrl}/ew-ice-jam--watch-and-act.svg?url`,
  'ew-ice-jam--advice': `${remoteHazardAssetsUrl}/ew-ice-jam--advice.svg?url`,

  // Lake Flooding
  'ew-lake-flooding--emergency-warning': `${remoteHazardAssetsUrl}/ew-lake-flooding--emergency-warning.svg?url`,
  'ew-lake-flooding--watch-and-act': `${remoteHazardAssetsUrl}/ew-lake-flooding--watch-and-act.svg?url`,
  'ew-lake-flooding--advice': `${remoteHazardAssetsUrl}/ew-lake-flooding--advice.svg?url`,

  // Power Outage (EMO graduated levels)
  'ew-power-outage--emergency-warning': `${remoteHazardAssetsUrl}/ew-power-outage--emergency-warning.svg?url`,
  'ew-power-outage--watch-and-act': `${remoteHazardAssetsUrl}/ew-power-outage--watch-and-act.svg?url`,

  // River Flooding
  'ew-river-flooding--emergency-warning': `${remoteHazardAssetsUrl}/ew-river-flooding--emergency-warning.svg?url`,
  'ew-river-flooding--watch-and-act': `${remoteHazardAssetsUrl}/ew-river-flooding--watch-and-act.svg?url`,
  'ew-river-flooding--advice': `${remoteHazardAssetsUrl}/ew-river-flooding--advice.svg?url`,

  // Seasonal Overland Flooding
  'ew-seasonal-overland-flooding--emergency-warning': `${remoteHazardAssetsUrl}/ew-seasonal-overland-flooding--emergency-warning.svg?url`,
  'ew-seasonal-overland-flooding--watch-and-act': `${remoteHazardAssetsUrl}/ew-seasonal-overland-flooding--watch-and-act.svg?url`,
  'ew-seasonal-overland-flooding--advice': `${remoteHazardAssetsUrl}/ew-seasonal-overland-flooding--advice.svg?url`,

  // Severe Winter Weather
  'ew-severe-winter-weather--emergency-warning': `${remoteHazardAssetsUrl}/ew-severe-winter-weather--emergency-warning.svg?url`,
  'ew-severe-winter-weather--watch-and-act': `${remoteHazardAssetsUrl}/ew-severe-winter-weather--watch-and-act.svg?url`,
  'ew-severe-winter-weather--advice': `${remoteHazardAssetsUrl}/ew-severe-winter-weather--advice.svg?url`,

  // Tornado
  'ew-tornado--emergency-warning': `${remoteHazardAssetsUrl}/ew-tornado--emergency-warning.svg?url`,
  'ew-tornado--watch-and-act': `${remoteHazardAssetsUrl}/ew-tornado--watch-and-act.svg?url`,
  'ew-tornado--advice': `${remoteHazardAssetsUrl}/ew-tornado--advice.svg?url`,

  // Bushfire
  'ew-bushfire--emergency-warning': `${remoteHazardAssetsUrl}/ew-bushfire--emergency-warning.svg?url`,
  'ew-bushfire--watch-and-act': `${remoteHazardAssetsUrl}/ew-bushfire--watch-and-act.svg?url`,
  'ew-bushfire--advice': `${remoteHazardAssetsUrl}/ew-bushfire--advice.svg?url`,

  // Coastal Hazards
  'ew-coastal-hazard--emergency-warning': `${remoteHazardAssetsUrl}/ew-coastal-hazard--emergency-warning.svg`,
  'ew-coastal-hazard--watch-and-act': `${remoteHazardAssetsUrl}/ew-coastal-hazard--watch-and-act.svg`,
  'ew-coastal-hazard--advice': `${remoteHazardAssetsUrl}/ew-coastal-hazard--advice.svg`,

  // Cyclone
  'ew-cyclone--emergency-warning': `${remoteHazardAssetsUrl}/ew-cyclone--emergency-warning.svg?url`,
  'ew-cyclone--watch-and-act': `${remoteHazardAssetsUrl}/ew-cyclone--watch-and-act.svg?url`,
  'ew-cyclone--advice': `${remoteHazardAssetsUrl}/ew-cyclone--advice.svg?url`,

  // Damaging Winds
  'ew-damaging-winds--emergency-warning': `${remoteHazardAssetsUrl}/ew-damaging-winds--emergency-warning.svg?url`,
  'ew-damaging-winds--watch-and-act': `${remoteHazardAssetsUrl}/ew-damaging-winds--watch-and-act.svg?url`,
  'ew-damaging-winds--advice': `${remoteHazardAssetsUrl}/ew-damaging-winds--advice.svg?url`,

  // Earthquake
  'ew-earthquake-alert': `${remoteHazardAssetsUrl}/ew-earthquake-alert.svg?url`,
  'ew-earthquake-final-alert': `${remoteHazardAssetsUrl}/ew-earthquake-final-alert.svg?url`,

  // Flood
  'ew-flood--emergency-warning': `${remoteHazardAssetsUrl}/ew-flood--emergency-warning.svg?url`,
  'ew-flood--watch-and-act': `${remoteHazardAssetsUrl}/ew-flood--watch-and-act.svg?url`,
  'ew-flood--advice': `${remoteHazardAssetsUrl}/ew-flood--advice.svg?url`,

  // Hazardous Materials
  'ew-hazmat-controlled-contained': `${remoteHazardAssetsUrl}/ew-hazmat-controlled-contained.svg?url`,
  'ew-hazmat-general-warning': `${remoteHazardAssetsUrl}/ew-hazmat-general-warning.svg?url`,
  'ew-hazardous-materials-warning': `${remoteHazardAssetsUrl}/ew-hazardous-materials-warning.svg?url`,

  // Heatwave
  'ew-heatwave--emergency-warning': `${remoteHazardAssetsUrl}/ew-heatwave--emergency-warning.svg?url`,
  'ew-heatwave--watch-and-act': `${remoteHazardAssetsUrl}/ew-heatwave--watch-and-act.svg?url`,
  'ew-heatwave--advice': `${remoteHazardAssetsUrl}/ew-heatwave--advice.svg?url`,

  // Human Pandemic Warning / State-wide Warning
  'ew-state-wide-warning': `${remoteHazardAssetsUrl}/ew-warning-state-wide.svg?url`,
  'ew-human-pandemic-warning': `${remoteHazardAssetsUrl}/ew-human-pandemic-warning.svg?url`,

  // Smoke or Other Alert
  'ew-smoke-alert': `${remoteHazardAssetsUrl}/ew-smoke-alert.svg?url`,
  'ew-other-warning': `${remoteHazardAssetsUrl}/ew-other-warning.svg?url`,

  // Storm
  'ew-storm--emergency-warning': `${remoteHazardAssetsUrl}/ew-storm--emergency-warning.svg?url`,
  'ew-storm--advice': `${remoteHazardAssetsUrl}/ew-storm--advice.svg?url`,
  'ew-storm--watch-and-act': `${remoteHazardAssetsUrl}/ew-storm--watch-and-act.svg?url`,

  // Storm Surge
  'ew-storm-surge--emergency-warning': `${remoteHazardAssetsUrl}/ew-storm-surge--emergency-warning.svg?url`,
  'ew-storm-surge--watch-and-act': `${remoteHazardAssetsUrl}/ew-storm-surge--watch-and-act.svg?url`,
  'ew-storm-surge--advice': `${remoteHazardAssetsUrl}/ew-storm-surge--advice.svg?url`,

  // Structure Fire
  'ew-structure-fire-warning': `${remoteHazardAssetsUrl}/ew-structure-fire-warning.svg?url`,
  'ew-structure-fire-contained-controlled': `${remoteHazardAssetsUrl}/ew-structure-fire-contained-controlled.svg?url`,

  // Tsunami
  'ew-tsunami-all-clear': `${remoteHazardAssetsUrl}/ew-tsunami-warning.svg?url`,
  'ew-tsunami-land-warning': `${remoteHazardAssetsUrl}/ew-tsunami-warning.svg?url`,
  'ew-tsunami-marine-warning': `${remoteHazardAssetsUrl}/ew-tsunami-warning.svg?url`,
  'ew-tsunami-watch': `${remoteHazardAssetsUrl}/ew-tsunami-warning.svg?url`,
  'ew-tsunami-warning': `${remoteHazardAssetsUrl}/ew-tsunami-warning.svg?url`,

  // Power Outage
  'ew-power-outage': `${remoteHazardAssetsUrl}/ew-power-outage.svg?url`,

  // Total Fire Ban
  'ew-total-fire-ban': `${remoteHazardAssetsUrl}/ew-total-fire-ban.svg?url`,

  // Community Information
  'ew-community-information': `${remoteHazardAssetsUrl}/ew-community-information.svg?url`,

  // General Warnings
  'ew-advice': `${remoteHazardAssetsUrl}/ew-advice.svg?url`,
  'ew-alert': `${remoteHazardAssetsUrl}/ew-alert.svg?url`,
  'ew-warning-location-specific': `${remoteHazardAssetsUrl}/ew-warning-location-specific.svg?url`,
  'ew-warning-state-wide': `${remoteHazardAssetsUrl}/ew-warning-state-wide.svg?url`,

  // Person Alerts
  'ew-amber-alert--emergency-warning': `${remoteHazardAssetsUrl}/ew-amber-alert--emergency-warning.svg?url`,
  'ew-dangerous-person--watch-and-act': `${remoteHazardAssetsUrl}/ew-dangerous-person--watch-and-act.svg?url`,
  'ew-missing-vulnerable-person--watch-and-act': `${remoteHazardAssetsUrl}/ew-missing-vulnerable-person--watch-and-act.svg?url`,
  'ew-silver-alert--watch-and-act': `${remoteHazardAssetsUrl}/ew-silver-alert--watch-and-act.svg?url`,

  // Arctic Outflow
  'ew-arctic-outflow--advice': `${remoteHazardAssetsUrl}/ew-arctic-outflow--advice.svg?url`,
  'ew-arctic-outflow--watch-and-act': `${remoteHazardAssetsUrl}/ew-arctic-outflow--watch-and-act.svg?url`,
  'ew-arctic-outflow--emergency-warning': `${remoteHazardAssetsUrl}/ew-arctic-outflow--emergency-warning.svg?url`,

  // Avalanche
  'ew-avalanche--advice': `${remoteHazardAssetsUrl}/ew-avalanche--advice.svg?url`,
  'ew-avalanche--watch-and-act': `${remoteHazardAssetsUrl}/ew-avalanche--watch-and-act.svg?url`,
  'ew-avalanche--emergency-warning': `${remoteHazardAssetsUrl}/ew-avalanche--emergency-warning.svg?url`,

  // Dust Storm
  'ew-dust-storm--advice': `${remoteHazardAssetsUrl}/ew-dust-storm--advice.svg?url`,
  'ew-dust-storm--watch-and-act': `${remoteHazardAssetsUrl}/ew-dust-storm--watch-and-act.svg?url`,
  'ew-dust-storm--emergency-warning': `${remoteHazardAssetsUrl}/ew-dust-storm--emergency-warning.svg?url`,

  // Earthquake (graduated)
  'ew-earthquake--advice': `${remoteHazardAssetsUrl}/ew-earthquake--advice.svg?url`,
  'ew-earthquake--watch-and-act': `${remoteHazardAssetsUrl}/ew-earthquake--watch-and-act.svg?url`,
  'ew-earthquake--emergency-warning': `${remoteHazardAssetsUrl}/ew-earthquake--emergency-warning.svg?url`,

  // Frost
  'ew-frost--advice': `${remoteHazardAssetsUrl}/ew-frost--advice.svg?url`,
  'ew-frost--watch-and-act': `${remoteHazardAssetsUrl}/ew-frost--watch-and-act.svg?url`,
  'ew-frost--emergency-warning': `${remoteHazardAssetsUrl}/ew-frost--emergency-warning.svg?url`,

  // Gale Wind
  'ew-gale-wind--advice': `${remoteHazardAssetsUrl}/ew-gale-wind--advice.svg?url`,
  'ew-gale-wind--watch-and-act': `${remoteHazardAssetsUrl}/ew-gale-wind--watch-and-act.svg?url`,
  'ew-gale-wind--emergency-warning': `${remoteHazardAssetsUrl}/ew-gale-wind--emergency-warning.svg?url`,

  // High Heat and Humidity
  'ew-high-heat-and-humidity--advice': `${remoteHazardAssetsUrl}/ew-high-heat-and-humidity--advice.svg?url`,
  'ew-high-heat-and-humidity--watch-and-act': `${remoteHazardAssetsUrl}/ew-high-heat-and-humidity--watch-and-act.svg?url`,
  'ew-high-heat-and-humidity--emergency-warning': `${remoteHazardAssetsUrl}/ew-high-heat-and-humidity--emergency-warning.svg?url`,

  // Hurricane
  'ew-hurricane--advice': `${remoteHazardAssetsUrl}/ew-hurricane--advice.svg?url`,
  'ew-hurricane--watch-and-act': `${remoteHazardAssetsUrl}/ew-hurricane--watch-and-act.svg?url`,
  'ew-hurricane--emergency-warning': `${remoteHazardAssetsUrl}/ew-hurricane--emergency-warning.svg?url`,

  // Hurricane Force Wind
  'ew-hurricane-force-wind--advice': `${remoteHazardAssetsUrl}/ew-hurricane-force-wind--advice.svg?url`,
  'ew-hurricane-force-wind--watch-and-act': `${remoteHazardAssetsUrl}/ew-hurricane-force-wind--watch-and-act.svg?url`,
  'ew-hurricane-force-wind--emergency-warning': `${remoteHazardAssetsUrl}/ew-hurricane-force-wind--emergency-warning.svg?url`,

  // Lahar
  'ew-lahar--advice': `${remoteHazardAssetsUrl}/ew-lahar--advice.svg?url`,
  'ew-lahar--watch-and-act': `${remoteHazardAssetsUrl}/ew-lahar--watch-and-act.svg?url`,
  'ew-lahar--emergency-warning': `${remoteHazardAssetsUrl}/ew-lahar--emergency-warning.svg?url`,

  // Landslide
  'ew-landslide--advice': `${remoteHazardAssetsUrl}/ew-landslide--advice.svg?url`,
  'ew-landslide--watch-and-act': `${remoteHazardAssetsUrl}/ew-landslide--watch-and-act.svg?url`,
  'ew-landslide--emergency-warning': `${remoteHazardAssetsUrl}/ew-landslide--emergency-warning.svg?url`,

  // Lava Flow
  'ew-lava-flow--advice': `${remoteHazardAssetsUrl}/ew-lava-flow--advice.svg?url`,
  'ew-lava-flow--watch-and-act': `${remoteHazardAssetsUrl}/ew-lava-flow--watch-and-act.svg?url`,
  'ew-lava-flow--emergency-warning': `${remoteHazardAssetsUrl}/ew-lava-flow--emergency-warning.svg?url`,

  // Magnetic Storm
  'ew-magnetic-storm--advice': `${remoteHazardAssetsUrl}/ew-magnetic-storm--advice.svg?url`,
  'ew-magnetic-storm--watch-and-act': `${remoteHazardAssetsUrl}/ew-magnetic-storm--watch-and-act.svg?url`,
  'ew-magnetic-storm--emergency-warning': `${remoteHazardAssetsUrl}/ew-magnetic-storm--emergency-warning.svg?url`,

  // Meteorite
  'ew-meteorite--advice': `${remoteHazardAssetsUrl}/ew-meteorite--advice.svg?url`,
  'ew-meteorite--watch-and-act': `${remoteHazardAssetsUrl}/ew-meteorite--watch-and-act.svg?url`,
  'ew-meteorite--emergency-warning': `${remoteHazardAssetsUrl}/ew-meteorite--emergency-warning.svg?url`,

  // Pyroclastic Flow
  'ew-pyroclastic-flow--advice': `${remoteHazardAssetsUrl}/ew-pyroclastic-flow--advice.svg?url`,
  'ew-pyroclastic-flow--watch-and-act': `${remoteHazardAssetsUrl}/ew-pyroclastic-flow--watch-and-act.svg?url`,
  'ew-pyroclastic-flow--emergency-warning': `${remoteHazardAssetsUrl}/ew-pyroclastic-flow--emergency-warning.svg?url`,

  // Pyroclastic Surge
  'ew-pyroclastic-surge--advice': `${remoteHazardAssetsUrl}/ew-pyroclastic-surge--advice.svg?url`,
  'ew-pyroclastic-surge--watch-and-act': `${remoteHazardAssetsUrl}/ew-pyroclastic-surge--watch-and-act.svg?url`,
  'ew-pyroclastic-surge--emergency-warning': `${remoteHazardAssetsUrl}/ew-pyroclastic-surge--emergency-warning.svg?url`,

  // Rainfall
  'ew-rainfall--advice': `${remoteHazardAssetsUrl}/ew-rainfall--advice.svg?url`,
  'ew-rainfall--watch-and-act': `${remoteHazardAssetsUrl}/ew-rainfall--watch-and-act.svg?url`,
  'ew-rainfall--emergency-warning': `${remoteHazardAssetsUrl}/ew-rainfall--emergency-warning.svg?url`,

  // Snowfall
  'ew-snowfall--advice': `${remoteHazardAssetsUrl}/ew-snowfall--advice.svg?url`,
  'ew-snowfall--watch-and-act': `${remoteHazardAssetsUrl}/ew-snowfall--watch-and-act.svg?url`,
  'ew-snowfall--emergency-warning': `${remoteHazardAssetsUrl}/ew-snowfall--emergency-warning.svg?url`,

  // Special Ice
  'ew-special-ice--advice': `${remoteHazardAssetsUrl}/ew-special-ice--advice.svg?url`,
  'ew-special-ice--watch-and-act': `${remoteHazardAssetsUrl}/ew-special-ice--watch-and-act.svg?url`,
  'ew-special-ice--emergency-warning': `${remoteHazardAssetsUrl}/ew-special-ice--emergency-warning.svg?url`,

  // Special Marine
  'ew-special-marine--advice': `${remoteHazardAssetsUrl}/ew-special-marine--advice.svg?url`,
  'ew-special-marine--watch-and-act': `${remoteHazardAssetsUrl}/ew-special-marine--watch-and-act.svg?url`,
  'ew-special-marine--emergency-warning': `${remoteHazardAssetsUrl}/ew-special-marine--emergency-warning.svg?url`,

  // Storm Force Wind
  'ew-storm-force-wind--advice': `${remoteHazardAssetsUrl}/ew-storm-force-wind--advice.svg?url`,
  'ew-storm-force-wind--watch-and-act': `${remoteHazardAssetsUrl}/ew-storm-force-wind--watch-and-act.svg?url`,
  'ew-storm-force-wind--emergency-warning': `${remoteHazardAssetsUrl}/ew-storm-force-wind--emergency-warning.svg?url`,

  // Tropical Storm
  'ew-tropical-storm--advice': `${remoteHazardAssetsUrl}/ew-tropical-storm--advice.svg?url`,
  'ew-tropical-storm--watch-and-act': `${remoteHazardAssetsUrl}/ew-tropical-storm--watch-and-act.svg?url`,
  'ew-tropical-storm--emergency-warning': `${remoteHazardAssetsUrl}/ew-tropical-storm--emergency-warning.svg?url`,

  // Tsunami (graduated)
  'ew-tsunami--advice': `${remoteHazardAssetsUrl}/ew-tsunami--advice.svg?url`,
  'ew-tsunami--watch-and-act': `${remoteHazardAssetsUrl}/ew-tsunami--watch-and-act.svg?url`,
  'ew-tsunami--emergency-warning': `${remoteHazardAssetsUrl}/ew-tsunami--emergency-warning.svg?url`,

  // Volcanic Ash Cloud
  'ew-volcanic-ash-cloud--advice': `${remoteHazardAssetsUrl}/ew-volcanic-ash-cloud--advice.svg?url`,
  'ew-volcanic-ash-cloud--watch-and-act': `${remoteHazardAssetsUrl}/ew-volcanic-ash-cloud--watch-and-act.svg?url`,
  'ew-volcanic-ash-cloud--emergency-warning': `${remoteHazardAssetsUrl}/ew-volcanic-ash-cloud--emergency-warning.svg?url`,

  // Volcano
  'ew-volcano--advice': `${remoteHazardAssetsUrl}/ew-volcano--advice.svg?url`,
  'ew-volcano--watch-and-act': `${remoteHazardAssetsUrl}/ew-volcano--watch-and-act.svg?url`,
  'ew-volcano--emergency-warning': `${remoteHazardAssetsUrl}/ew-volcano--emergency-warning.svg?url`,

  // Waterspout
  'ew-waterspout--advice': `${remoteHazardAssetsUrl}/ew-waterspout--advice.svg?url`,
  'ew-waterspout--watch-and-act': `${remoteHazardAssetsUrl}/ew-waterspout--watch-and-act.svg?url`,
  'ew-waterspout--emergency-warning': `${remoteHazardAssetsUrl}/ew-waterspout--emergency-warning.svg?url`,
};
